// Anzeigetexte zu den Datenfeldern des OSP-Fragebogens.
// Muss zu backend/auswertung.py passen. Massgeblich ist immer der Text, den die Eltern im
// Formular gelesen haben (OSPFragebogen.jsx) – im Zungen-Block weichen die Feldnamen davon ab.

export const GRUENDE = [
  ['offeneMundhaltung', 'Offene Mundhaltung'],
  ['mundatmung', 'Mundatmung'],
  ['schnarchen', 'Schnarchen'],
  ['zaehneKnirschen', 'Zähneknirschen'],
  ['schwacheLippen', 'Schwache Lippen'],
  ['verkuerzteOberlippe', 'Verkürzte Oberlippe'],
  ['wulstigeUnterlippe', 'Wulstige Unterlippe'],
  ['raueLippen', 'Raue, rissige Lippen'],
  ['undeutlichesSprechen', 'Undeutliches Sprechen'],
  ['naeseln', 'Näseln'],
  ['lautfehlbildungen', 'Lautfehlbildungen'],
  ['zahnKieferfehlstellungen', 'Zahn-/Kieferfehlstellungen'],
];

export const BEGLEITBEFUNDE = [
  ['angewohnheiten', 'Schädliche Angewohnheiten', [
    ['daumenlutschen', 'Daumenlutschen'],
    ['schnullergebrauch', 'Schnullergebrauch'],
    ['fingernaegel', 'Fingernägelkauen'],
    ['lippenbeissen', 'Lippenbeißen'],
    ['saugenZunge', 'Saugen an der Zunge'],
    ['saugenWangen', 'Saugen an den Wangen'],
  ]],
  ['lippeneinzug', 'Lippeneinzug', [
    ['unterlippe', 'Unterlippe'],
    ['oberlippe', 'Oberlippe'],
    ['lippenbeissen', 'Lippenbeißen'],
  ]],
  ['zungenposition', 'Zungenposition und -bewegung', [
    ['zungenTieflage', 'Zungentieflage'],
    ['zungenEinlagerungUkOk', 'Einlagerung zwischen OK und UK'],
    ['zungenEinlagerungLippen', 'Einlagerung zwischen den Lippen'],
    ['zungendruckSchluckenOk', 'Schlucken: gegen den OK'],
    ['zungendruckOkUk', 'Schlucken: zwischen OK und UK'],
    ['zwischenLippen', 'Schlucken: gegen den UK'],
    ['zungendruckSprechenUk', 'Schlucken: zwischen die Lippen'],
    ['zungendruckOkLippen', 'Sprechen: gegen den OK'],
    ['gegenUk', 'Sprechen: gegen den UK'],
    ['zwischenOkUk', 'Sprechen: zwischen OK und UK'],
    ['zwischenLippenSprechen', 'Sprechen: zwischen die Lippen'],
  ]],
  ['nahrungsaufnahme', 'Nahrungsaufnahme', [
    ['babyflasche', 'Babyflasche'],
    ['trinkenStrohalm', 'Strohhalm, Zapfenbecher, Flasche'],
    ['breiigeNahrung', 'Breiige Nahrung'],
    ['weichereNahrung', 'Weichere Nahrung bevorzugt'],
  ]],
  ['zungenbewegung', 'Kauen', [
    ['schmatzen', 'Schmatzen beim Essen'],
    ['nahrungAustritt', 'Nahrung tritt aus dem Mund aus'],
  ]],
  ['artikulationsmerkmale', 'Stimmklang und Artikulation', [
    ['stimmklangNasal', 'Stimmklang nasal'],
    ['stimmklangHeiser', 'Stimmklang heiser'],
    ['insgesamtUndeutlich', 'Insgesamt undeutlich'],
  ]],
];

export const SKALEN = [
  ['gesamtentwicklung', 'Auswirkung auf die Gesamtentwicklung',
    [['gar_nicht', 'Gar nicht'], ['leicht', 'Leicht'], ['gut', 'Gut'], ['sehr_gut', 'Sehr gut']]],
  ['handhabung', 'Handhabung der OSP',
    [['schwierig', 'Schwierig'], ['unterschiedlich', 'Unterschiedlich'], ['leicht', 'Leicht'], ['problemlos', 'Problemlos']]],
  ['anwendungAlltag', 'Anwendung im Alltag nach Eingewöhnung',
    [['schwierig', 'Schwierig'], ['unterschiedlich', 'Unterschiedlich'], ['leicht', 'Leicht'], ['problemlos', 'Problemlos']]],
];

export const ZUSTIMMUNG = ['', 'Stimme gar nicht zu', 'Stimme nicht zu', 'Teils/teils', 'Stimme zu', 'Stimme voll zu'];
